import { useMemo } from "react";
import type { CSSProperties } from "react";
import type { Persona } from "../domain/types";

/**
 * Translate a Persona's `themeColor` (HSL string) into CSS variables
 * consumable by Tailwind utility classes (`hsl(var(--persona-glow))`).
 */
export function usePersonaTheme(persona: Persona | null | undefined): CSSProperties {
  return useMemo<CSSProperties>(() => {
    if (!persona) return {};
    const hsl = parseHsl(persona.themeColor);
    if (!hsl) return {};
    return {
      ["--persona-glow" as string]: hsl,
      ["--persona-fill" as string]: hsl,
    };
  }, [persona]);
}

/** Parse an HSL string like "hsl(220 14% 80%)" into the bare "H S% L%" body. */
function parseHsl(input: string): string | null {
  const match = input.match(/hsl\(\s*([^)]+?)\s*\)/i);
  return match ? match[1]!.replace(/,/g, " ").replace(/\s+/g, " ").trim() : null;
}
